import type { Domain } from 'auth-common/domain';
import { Const } from 'auth-common/shared';
import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

type Organization = Domain.Object.Organization;

export const latestOrganizationIdAtom = atomWithStorage<Organization['id'] | undefined>(
  Const.LocalStorage.LatestOrganizationId,
  undefined,
  undefined,
  { getOnInit: true },
);

export const useLatestOrganizationId = () => {
  const [latestOrganizationId, setLatestOrganizationId] = useAtom(latestOrganizationIdAtom);
  return { latestOrganizationId, setLatestOrganizationId };
};
